<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <ShippingMethodTransportationForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import ShippingMethodTransportationForm from "@/components/settings/test-registers/shippingmethodtransportation/ShippingMethodTransportationForm";

export default {
  name: "ShippingMethodTransportationAdd",
  components: {
    PageTitle,
    PageRowWrapper,
    ShippingMethodTransportationForm,
  },
};
</script>
